import { bool, func, node, string, number, oneOfType, object } from "prop-types";
import { ClearInput } from "@components";
import { Divider } from "@material-ui/core";
import useStyle from "../Totals.style";

export const TotalValueEditable = ({
  min,
  max,
  symbolStart,
  symbolEnd,
  showMaxValue,
  onValueChange,
  children,
  maxValue,
  showAllSymbols=false,
  ...inputProps
}) => {
  const classes = useStyle();
  
  const handleValueChange = (isMax) => (value) => {
    onValueChange && onValueChange(value, isMax);
  };
  
  return (
    <>
      <ClearInput
        value={min.toString()}
        onChange={handleValueChange(false)}
        alignContent="center"
        maxWidth
        max={maxValue}
        prefix={symbolStart}
        suffix={showAllSymbols || !showMaxValue ? symbolEnd : undefined}
        {...inputProps}
      />
      {
        showMaxValue &&
        <Divider className={classes.totalValueDivider} />
      }
      {
        showMaxValue &&
        <ClearInput
          value={max}
          onChange={handleValueChange(true)}
          alignContent="center"
          maxWidth
          max={maxValue}
          prefix={showAllSymbols ? symbolStart : undefined}
          suffix={symbolEnd}
          {...inputProps}
        />
      }
      {children}
    </>
  )
}

TotalValueEditable.propTypes = {
  min: oneOfType([number, string]).isRequired,
  max: oneOfType([number, string]),
  children: node, //additional items to show after value & symbols
  symbolStart: string,
  symbolEnd: oneOfType([node, string]),
  showMaxValue: bool,
  onValueChange: func,
  showDecimals: bool,
  fixedDecimalScale: bool,
  allowNegative: bool,
  style: object,
  maxValue: number,
  decimals: number,
  americanFormat: bool,
  showAllSymbols: bool,
}